import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EmailTemplateService {

  constructor(private httpClient: HttpClient) { }

  getAllPagesFlat(id) {

     return this.httpClient.get<any[]>(`/Pages/GetAllPagesFlat/0/0/2/${id}`)
  }

  getEmailTypes() {
   return this.httpClient.get(`/EmailTemplate/GetEmailTemplateTypes`)
  }

  GetEmailTemplateById(id) {
    let prams = { id : id}
  return  this.httpClient.post(`/EmailTemplate/GetEmailTemplateById`,prams)
  }
   getFormName(emailTemplate) {

    return  this.httpClient.get(`/Forms/GetAllKeys?PageId=${emailTemplate.additionalInfo.pageId}`)
   }
   getKeys(emailTemplate) {
    
    return  this.httpClient.get(`/Forms/GetAllKeys?PageId=${emailTemplate.additionalInfo.pageId}`)
   }
editTemplate(body){

  return this.httpClient.put('/EmailTemplate/EditTemplate/', body)
}
addTemplate(body){
  return this.httpClient.post('/EmailTemplate/addTemplate', body)
}
    
}
